var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "qbvkpzsc2a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.662745 0 0 0 0 0.992157 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#00A9FD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.988 10.9 8.234 5.071M2.4 10.9l5.657-5.657"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBlue);
export default __webpack_public_path__ + "static/media/arrowUpBlue.6a53a6e95947f86cb3873006d1c174c4.svg";
export { ForwardRef as ReactComponent };